
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/world/partners/[id]",
      function () {
        return require("private-next-pages/world/partners/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/world/partners/[id]"])
      });
    }
  